import { Component, OnInit } from '@angular/core';

@Component({
    templateUrl: 'developer.component.html',
  standalone: false
})

export class DeveloperComponent implements OnInit {
    constructor() { }

    ngOnInit() { }
}